export const AIRHELP_GLOBAL_COOKIE_DOMAIN = ["sta", "production"].includes(import.meta.env.MODE)
  ? ".airhelp.com"
  : undefined;
